// Regiao de Estudo
import api from '@/api';
import axios from 'axios';
import _ from 'lodash';
import Vue from 'vue';

export default function (data) {

  var state = {
    forms: {}, // { name:{fields:fields,values:values}}
    validations:{}
  }


  return {

    state: state,
    // namespaced: true,

    mutations: {

      addForm: function (state, {name, fields, values}) {

            var forms = {...state.forms};
            forms[name] = {fields:fields, values:values}
            state.forms = forms;
      },

      addField: function(state, {formName, fieldName, value}){
     
          var forms = {...state.forms};
          if( ! _.has(forms,formName)){
            forms[formName] = {fields:{}, values:{}}
          }
          forms[formName].fields[fieldName] = {value}
          forms[formName].values[fieldName]  = value
          state.forms = forms;
      },

      removeField: function(state, {formName, fieldName, value}){
          var forms = {...state.forms};
          if(  _.has(forms,formName)){
            forms[formName].fields = _.omit(forms[formName].fields,fieldName)
            forms[formName].values = _.omit(forms[formName].values,fieldName)
            // delete forms[formName].values[fieldName]
          }
          state.forms = forms;
      },

      updateForm: function (state, {name,fields, values}) {
            var forms = {...state.forms};
            forms[name] = {fields:fields, values:values}
            state.forms = forms;
      },

      updateValueForFormField: function(state, {formName,key,value}){
          var forms = {...state.forms};
          
          _.set(forms,`${formName}.values.${key}`,value)
          state.forms = forms;
      },

      removeForm: function (state, {name,fields}) {
        var forms = {...state.forms};
        delete form[name];
        state.forms = forms;
     },


    },

    actions: {

    

    },

    getters: {
        formFields: state => formName => {
            return _.get(state.forms,formName+'.fields',[]);
        },

        valueForFormField: state => (formName,fieldName) =>{
          return _.get(state.forms,`${formName}.values.${fieldName}`,'');
        },
        valueForForm: state => (formName) =>{
          
          return _.get(state.forms,`${formName}.values`,{});
        }
      
    }
  }
}
